<app-header></app-header>
<span class="mt-4"></span>
<app-landing-page-simulador-preco></app-landing-page-simulador-preco>